import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from './../../globalModule/assets/close-circle.svg'
import _imports_1 from './../../globalModule/assets/ask_question.svg'


const _hoisted_1 = { class: "heading-div" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "heading-text" }, "Login With Git", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", { class: "icon-button" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/apps/miros-app/installations/select_target",
  target: "_blank"
}, "here", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('')))
      }, _hoisted_3),
      _hoisted_4,
      _hoisted_5
    ]),
    (_ctx.installed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Congratulations, you have successfully authenticated with your git account. Close this page and click on the git button in the control centre to access the git menu. "))
      : _createCommentVNode("", true),
    (!_ctx.installed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createTextVNode(" Nearly there! a new tab should have opened up prompting you to install the MiROS app on your account. Select the account on which you want to install MiROS and click \"install\". If no tab opened up simply click "),
          _hoisted_8,
          _createTextVNode(" to open the window. Once you have installed the app, close this window and click the git menu button again to open the git menu. ")
        ]))
      : _createCommentVNode("", true)
  ], 64))
}